import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-tailwind/react";
import useAppContext from "state/AppContext";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  CircleStackIcon,
  DocumentIcon,
  DocumentTextIcon,
  PaperClipIcon,
} from "@heroicons/react/24/solid";

export default function OrderDashboardDocuments() {
  const appContext = useAppContext();
  const { documents } = appContext.selectedOrder;
  const { servicesProposal, servicesContract, confidentialAgreement, invoices } = documents;

  const [showContent, setShowContent] = useState(true);

  function handleToggle() {
    setShowContent(!showContent);
  }

  const containerStyles = "mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";
  const buttonStyles = `w-full flex items-stretch justify-between py-4 px-6 ${showContent ? "border-b border-b-gray-300" : ""}`;

  return (
    <div className={containerStyles}>
      <button className={buttonStyles} onClick={handleToggle}>
        <header className="flex items-center flex-1">
          <div className="bg-blue-600 rounded-lg p-1 flex items-center justify-center h-[25px] w-[25px] mr-2">
            <CircleStackIcon className="h-3 w-3 text-white" />
          </div>
          <h3 className="text-lg font-semibold">Documents</h3>
        </header>
        <footer className="flex items-center ">
          {showContent ? <ChevronUpIcon className="block h-4 w-4" /> : <ChevronDownIcon className="block h-4 w-4" />}
        </footer>
      </button>
      {showContent ? (
        <div>
          <Link to={servicesProposal} target="_blank">
            <Button variant="text" className="flex items-center gap-3">
              <DocumentIcon strokeWidth={2} className="h-5 w-5" /> Services Proposal
            </Button>
          </Link>
          <Link to={servicesContract} target="_blank">
            <Button variant="text" className="flex items-center gap-3">
              <DocumentTextIcon strokeWidth={2} className="h-5 w-5" /> Services Contract
            </Button>
          </Link>
          <Link to={confidentialAgreement} target="_blank">
            <Button variant="text" className="flex items-center gap-3">
              <DocumentTextIcon strokeWidth={2} className="h-5 w-5" /> Confidential Agreement (NDA)
            </Button>
          </Link>
          {invoices.map((invoice) => (
            <Link key={invoice.id} to={invoice.url} target="_blank" className="pointer-events-none">
              <Button variant="text" className="flex items-center gap-3" disabled>
                <PaperClipIcon strokeWidth={2} className="h-5 w-5" /> {invoice.name}
              </Button>
            </Link>
          ))}
        </div>
      ) : null}
    </div>
  );
}
